import '../assets/styles/Header.css';
import { useState } from "react";

const Header = () => {
  const [showRules, setShowRules] = useState(false);

  return (
    <div className='header'>
      <div className="gameName">Mastermind</div>
      <div className="rules" onClick={() => setShowRules(!showRules)}>
        {(showRules) ? 'Hide rules' : 'Show rules'}
      </div>
      {(showRules) && <div className="rulesContent">
      Try to guess the pattern, in both order and color, within ten turns. After submitting
      a row, a small green square is shown for each circle in a correct position and color. A yellow 
      square indicates the existence of correct color in an incorrect position.
      More on <a href="https://en.wikipedia.org/wiki/Mastermind_(board_game)"  target="_blank" rel="noreferrer">Wikipedia.</a> 
      </div>}
    </div>
  )

}

export default Header;